var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.306,
    height: 22.47,
    viewBox: "0 0 25.306 22.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-hd-wallet-2199724",
    transform: "translate(-96.253 -39.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M119.359,44.306a2.2,2.2,0,0,1,2.2,2.193V59.106a2.746,2.746,0,0,1-2.751,2.741H99a2.746,2.746,0,0,1-2.751-2.741V43.21a2.2,2.2,0,0,1,2.2-2.193h11.1l4.455-1.608a.544.544,0,0,1,.7.323l.47,1.285h1.985a2.2,2.2,0,0,1,2.2,2.193Zm-2.2-2.193h-1.586l.8,2.193h1.886v-1.1a1.1,1.1,0,0,0-1.1-1.1Zm-7.458,0-6.073,2.193h11.587l-.764-2.093-.584-1.6-1.128.407h0l-3.033,1.1Zm-11.247,0a1.1,1.1,0,1,0,0,2.192h2c.008,0,.011-.009.019-.011l6.041-2.181Zm22.006,13.155V46.5a1.1,1.1,0,0,0-1.1-1.1H98.454a2.185,2.185,0,0,1-1.1-.3V59.105A1.648,1.648,0,0,0,99,60.75h19.8a1.647,1.647,0,0,0,1.65-1.644Z",
    fill: "#0b8369",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M261.1,215.183h-2.354a.208.208,0,0,0-.2.2V218.7a.208.208,0,0,1-.2.2h-1.989a.208.208,0,0,1-.2-.2v-2.311a.421.421,0,0,0-.419-.419h-1.556a.421.421,0,0,0-.419.419v5.568a.421.421,0,0,0,.419.419h1.556a.421.421,0,0,0,.419-.419v-2.311a.208.208,0,0,1,.2-.2h2.016a.208.208,0,0,1,.2.2v3.325a.208.208,0,0,0,.2.2h2.354a.193.193,0,0,1,.176.122,1.048,1.048,0,0,0,1.177.662,1.068,1.068,0,0,0,.852-.838,1.078,1.078,0,0,0-2.056-.622.175.175,0,0,1-.176.122h-1.813a.208.208,0,0,1-.2-.2v-2.784a.208.208,0,0,1,.2-.2H261.1a.193.193,0,0,1,.176.122,1.075,1.075,0,1,0,0-.8.175.175,0,0,1-.176.122h-1.813a.208.208,0,0,1-.2-.2v-2.784a.208.208,0,0,1,.2-.2H261.1a.193.193,0,0,1,.176.122,1.068,1.068,0,0,0,2.056-.135,1.078,1.078,0,0,0-2.056-.622.187.187,0,0,1-.176.135Z",
    transform: "translate(-149.645 -166.269)",
    fill: "#0b8369"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.41cc74f26e3e8712295244ba6e5eadee.svg";
export { ForwardRef as ReactComponent };